export default __webpack_public_path__ + "static/media/twitter.0ff9cb1b.svg";